var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.78bd417b3153e7e4af191914b6ae7fc1.svg#y';
                    var viewUrl = 'sprites.78bd417b3153e7e4af191914b6ae7fc1.svg#view-y';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 35 26',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };